import { BaseEntity } from "./BaseEntity";

export class Audit implements BaseEntity {
  constructor(
    public id?: number,
    public eventTime?: Date,
    public username?: string,
    public action?: string,
    public recordType?: string,
    public recordID?:string,
    public name?: string,
    public description?: string,
    public rfidTag?: string,
    public vTagID?: string,
    public vTagGpsDeviceID?: string,
    public assetType?: string,
    public departmentCode?: string,
    public lastObservedLocation?: string,
    public lastObservedTime?: Date,
    public date1?: Date,
    public date2?: Date,
    public date3?: Date,
    public date4?: Date,
    public date5?: Date,
    public listValue1?: string,
    public listValue2?: string,
    public listValue3?: string,
    public listValue4?: string,
    public listValue5?: string,
    public text1?: string,
    public text2?: string,
    public text3?: string,
    public text4?: string,
    public text5?: string,
    public text6?: string,
    public text7?: string,
    public text8?: string,
    public text9?: string,
    public text10?: string,
    public text11?: string,
    public text12?: string,
    public text13?: string,
    public text14?: string,
    public text15?: string,
    public text16?: string,
    public text17?: string,
    public text18?: string,
    public text19?: string,
    public text20?: string,
  ) {
  }

  parseJson(json: any): void {
    this.id = json.id;
    this.eventTime = json.eventTime;
    this.username = json.username;
    this.action = json.action;
    this.recordType = json.recordType;
    this.recordID = json.recordID;
    this.name = json.name;
    this.description = json.description;
    this.rfidTag = json.rfidTag;
    this.vTagID = json.vTagID;
    this.vTagGpsDeviceID = json.vTagGpsDeviceID;
    this.assetType = json.assetType;
    this.departmentCode = json.departmentCode;
    this.lastObservedLocation = json.lastObservedLocation;
    this.lastObservedTime = json.lastObservedTime;
    this.date1 = json.date1;
    this.date2 = json.date2;
    this.date3 = json.date3;
    this.date4 = json.date4;
    this.date5 = json.date5;
    this.listValue1 = json.listValue1;
    this.listValue2 = json.listValue2;
    this.listValue3 = json.listValue3;
    this.listValue4 = json.listValue4;
    this.listValue5 = json.listValue5;
    this.text1 = json.text1;
    this.text2 = json.text2;
    this.text3 = json.text3;
    this.text4 = json.text4;
    this.text5 = json.text5;
    this.text6 = json.text6;
    this.text7 = json.text7;
    this.text8 = json.text8;
    this.text9 = json.text9;
    this.text10 = json.text10;
    this.text11 = json.text11;
    this.text12 = json.text12;
    this.text13 = json.text13;
    this.text14 = json.text14;
    this.text15 = json.text15;
    this.text16 = json.text16;
    this.text17 = json.text17;
    this.text18 = json.text18;
    this.text19 = json.text19;
    this.text20 = json.text20;
  }
}
